module.exports = __webpack_public_path__ + "68a97dfbdb03f586349294cbdecbbfff.svg";